module.exports = __webpack_public_path__ + "img/L_JD.64e9f2d0.png";